import React from 'react'
import ConnectedComponent from '../../../shared/connecter/ConnectedComponent'
import FontIcon from 'material-ui/FontIcon'
import Unique from '../../../shared/utils/Unique'
import moment from 'moment'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import CloseIcon from 'material-ui/svg-icons/navigation/close'
import RaisedButton from 'material-ui/RaisedButton'
import {playerTotalGame} from '../../../game/level/components/types/TotalLevelComponent'
import PodiumComponent from '../../leaderboards/components/PodiumComponent'
import {Badge, BadgeList, fontStyle} from './BadgeListComponent'
moment.locale('fr')


const style = {
    marginRight: 20,
    position: 'absolute',
    bottom: -20,
    right: 20
}

class CloseButton extends ConnectedComponent {
    render() {
        return (<FloatingActionButton onTouchTap={this.props.close ? this.props.close : this.start} style={style}>
            <CloseIcon />
        </FloatingActionButton>)
    }
}


function playerGameResult(props) {
    const {game, size} = props

    const classSize = `col-md-${size} col-xs-${size} col-sm-${size}`
    return game.players.sort((a, b) => a.name > b.name).map(player => {
        const winner = player.name === game.winner.name //? <FontIcon className="fa fa-trophy" />: null
        const style = {padding: '10px 10px'}
        const wstyle = winner ? {
                ...style,
                backgroundColor: '#F0F0F0'
            } : style
        return (<div className={classSize} style={wstyle} key={player.name}>
            <div style={{}} className="pull-right">
                {player.total}
            </div>
            <div className="">
                {winner ? <strong>{player.name}</strong> : player.name }
            </div>
            <div className="pull-left" style={{marginTop: '10px'}}>
                {winner ?
                    <Badge title="Gagnant !"><FontIcon style={fontStyle} className="fa fa-trophy"/></Badge> : null}
                {BadgeList(player)}
            </div>
        </div>)
    })
}


class GameResult extends React.Component {
    render() {
        const {game, size, disableDate} = this.props
        const style = {padding: '10px 10px'}

        const _size = size || 4

        const players = playerGameResult({game, size: _size})
        const classSize = `col-md-${_size} col-xs-${size} col-sm-${_size}`

        return (<div className="row" style={{borderBottom: '1px solid #DDD'}}>
            <div className={classSize} style={style}>
                {disableDate ? ' ' : moment(game.date).format('LLL')}
            </div>
            {players}
        </div>)
    }
}
class TotalPlayersResult extends React.Component {
    render() {
        const {player, size, style, prop} = this.props
        const key = prop || 'totals'
        const _style = Object.assign({},{padding: '10px 10px'}, style || {} )

        const _size = size || 4

        const classSize = `col-md-${_size} col-xs-${size} col-sm-${_size}`

        return (<div className={classSize + ' text-center'} style={_style}>
            {player[key]}
        </div>)
    }
}

function getTotals (games) {
    return games.reduce((prev, current) => {
        // UPDATING LIST OF PLAYERS
        current.players.map(player => {
            if (!prev.find(o => o.name === player.name)) {
                prev.push({
                    name: player.name,
                    wins: 0,
                    totals: 0,
                    badges: 0
                })
            }
        })

        //counting victories
        const item = prev.find(o => o.name === current.winner.name)
        item.wins++

        //All Points
        current.players.map(player => {
            const item = prev.find(o => o.name === player.name)
            item.totals += playerTotalGame(player)
        })

        //badge count
        current.players.map(player => {
            const item = prev.find(o => o.name === player.name)
            const winner = current.winner.name === player.name ? 1 : 0
            item.badges += BadgeList(player).length + winner
        })

        return prev
    }, [])
}


class Podium extends PodiumComponent {
    render(){
        const uid = () => new Unique().gen()
        const {games} = this.props
        const PlayerConstructor = this.PlayerConstructor
        const PlayerListItemConstructor = this.PlayerListItemConstructor
        const leaders = games.concat().slice(0, 3)
            .map(game=><PlayerConstructor date={game.date} key={game.id || uid()} player={game.winner}/>)
        const others = games.concat().slice(3, 10)
            .map(game=><PlayerListItemConstructor date={game.date} key={game.id || uid()} player={game.winner}/>)
        return (
            <div className="podium">
                <div className="leaders">
                    {leaders}
                </div>
                <div className="others">
                    {others}
                </div>
            </div>
        )
    }
}

class TotalResult extends React.Component {

    totals = (games, style, size) => {
        const totals = getTotals(games).map(player => <TotalPlayersResult style={style} key={player.name} player={player} />)
        const classSize = `col-md-${size} col-xs-${size} col-sm-${size}`
        return (<div className="row" style={{backgroundColor: '#E8F5E9',borderBottom: '1px solid #d9e8da'}}>
            <div className={classSize} style={style}>
                <strong>Total points</strong>
            </div>
            {totals}
        </div>)
    }

    badges = (games, style, size) => {
        const totals = getTotals(games).map(player => <TotalPlayersResult prop={'badges'} style={style} key={player.name} player={player} />)
        const classSize = `col-md-${size} col-xs-${size} col-sm-${size}`
        return (<div className="row" style={{backgroundColor: '#E8F5E9',borderBottom: '1px solid #d9e8da'}}>
            <div className={classSize} style={style}>
                <strong>Nombre de badges</strong>
            </div>
            {totals}
        </div>)
    }


    victories = (games, style, size) => {
        const totals = getTotals(games).map(player => <TotalPlayersResult prop={'wins'} style={style} key={player.name} player={player} />)
        const classSize = `col-md-${size} col-xs-${size} col-sm-${size}`
        return (<div className="row" style={{backgroundColor: '#E8F5E9',borderBottom: '1px solid #d9e8da'}}>
            <div className={classSize} style={style}>
                <strong>Nombre de victoires</strong>
            </div>
            {totals}
        </div>)
    }

    topChart = (games, style) => {
        //const totals = getTotals(games).map(player => <TotalPlayersResult prop={'wins'} style={style} key={player.name} player={player} />)
        //
        const topGames = games.sort(scoreSorter).reverse()

        /*
        const tops = topGames.map((game, index )=> {
            const size = 4
            const classSize = `col-md-${size} col-xs-${size} col-sm-${size}`
            return (<div className="row" key={game.id} style={{...style}}>
                <div className={classSize}>
                    {index+1}
                </div>
                <div className={classSize + ' text-center'}>
                    {game.winner.name}
                </div>
                <div className={classSize + ' text-center'}>
                    {game.winner.total}
                </div>
            </div>)
        })
        */

        return (<div style={{margin:'20px 0'}}>
            <div className="row" style={{...style,backgroundColor:'#fff2ab' }}>
                <strong>Meilleurs Scores</strong>
            </div>
            <Podium games={topGames}/>
        </div>)
    }

    render() {
        const {games, size} = this.props
        const style = {padding: '10px 10px', lineHeight:'40px'}

        const _size = size || 4

        return (<div>
            {this.totals(games, style, _size)}
            {this.badges(games, style, _size)}
            {this.victories(games, style, _size)}
            {this.topChart(games, style, _size)}

        </div>)
    }
}


function dateSorter(a, b) {
    const da = new Date(a.date);
    const db = new Date(b.date);
    if (da < db) return -1;
    if (da > db) return 1;
    return 0;
}

function scoreSorter(a, b) {
    const da = a.winner.total;
    const db = b.winner.total;
    if (da < db) return -1;
    if (da > db) return 1;
    return 0;
}


class DayComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false
        }
    }
    toggle = (state) => {
        this.setState({
            visible: typeof state === 'boolean' ? state : !this.state.visible
        })
    }

    render() {
        const {games, title} = this.props
        const players = getTotals(games)

        const list = players.map(player => {
            return (<div className="col-md-4 col-sm-4 text-center" key={title + '-' + player.name}>
                {player.name} <strong>{player.wins}</strong>
            </div>)
        })

        const gamesList = games.map((item) => (<GameResult disableDate={true} key={item.id} game={item}/>))

        gamesList.push(<TotalResult games={games} key="totals" />)
        const style = {lineHeight: '50px', height: '50px', backgroundColor: '#A5D6A7', cursor:'pointer',borderBottom: '1px solid #9dce9f'}


        return (<div>
            <div className="row" style={style} onTouchTap={this.toggle}>
                <div className="col-md-4 col-sm-4">
                    {title}
                </div>
                {list}
            </div>
            {this.state.visible ? <div className="animated fadeIn" style={{position: 'relative'}} children={gamesList} />: null}
        </div>)
    }
}

class DailyStat extends ConnectedComponent {

    constructor(props) {
        super(props)
        this.state = {
            mode: 'daily'
        }
    }

    setMode = (mode) => {
        this.setState({
            mode: mode
        })
    }

    raw() {
        const history = this.store.playedGamesHistory.toJSON()
        return history.sort(dateSorter).reverse().map(item => <GameResult key={item.id} game={item}/>)
    }

    daily() {
        const history = this.store.playedGamesHistory.toJSON()
        const list = history.sort(dateSorter).reverse().reduce((prev, current) => {
            const day = moment(current.date).format('LL')
            const item = prev.find(o => o.day === (day))
            if (!item) {
                prev.push({
                    day,
                    games: [current]
                })
            } else {
                item.games.push(current)
            }
            return prev
        }, [])

        return list.map(item => <DayComponent key={item.day} games={item.games} title={item.day}/>)
    }

    render() {

        const mode = this.state.mode
        //const bton = RaisedButton
        const games = this.store.playedGamesHistory.toJSON()
        return (
            <div>
                <h4>{this.props.title || 'Historique'}</h4>
                <div style={{padding: '10px 0'}}>
                    <RaisedButton primary={mode==='raw'} label={'Tous'} onTouchTap={() => this.setMode('raw')}/>
                    <RaisedButton style={{marginLeft:'10px'}} primary={mode==='daily'} label={'Par jour'} onTouchTap={() => this.setMode('daily')}/>
                </div>
                <div style={{padding: '10px'}}>
                    <div className="row" style={{borderBottom: '1px solid #DDD'}}/>
                    {mode === 'daily' ? this.daily() : this.raw()}
                </div>
                <div  style={{padding: '10px'}}>
                    <TotalResult games={games} key="totals" />
                </div>

                {this.props.button ? <CloseButton close={this.props.close}/> : null}
            </div>)
    }
}


export default DailyStat


// WEBPACK FOOTER //
// ./src/game/stats/components/StatsComponent.js